function dateInputValue(value) {
  const text = String(value ?? '').trim();
  const iso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T].*)?$/);
  const indian = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (!iso && !indian) return '';
  const [year, month, day] = iso ? [Number(iso[1]), Number(iso[2]), Number(iso[3])]
    : [Number(indian[3]), Number(indian[2]), Number(indian[1])];
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function ptInvoiceDate(preview) {
  const explicit = dateInputValue(preview.supplierInvoiceDate);
  if (explicit) return explicit;
  const sources = preview.summary?.dates?.length ? preview.summary.dates
    : (preview.items || []).map(item => item.catalogDraft?.date || item.pt?.date).filter(Boolean);
  const dates = [...new Set(sources.map(dateInputValue))];
  // Never guess ambiguous short-year text or use the receipt date as a fallback.
  return dates.length === 1 && dates[0] ? dates[0] : '';
}
